import { axiosInstance } from "@/utils/axios";
import { companyMatchRoutingHeaders } from "@/utils/companyMatchRouting";

const COMPANY_MATCH_API_URL = "/company-match-api/api";

/**
 * Download CSV with detailed match results for an uploaded file
 */
export async function downloadMatchDetails(fileId: string): Promise<void> {
  const response = await axiosInstance.get(`${COMPANY_MATCH_API_URL}/details`, {
    params: { file_id: fileId },
    headers: companyMatchRoutingHeaders(),
    responseType: "blob",
  });

  const url = URL.createObjectURL(response.data);
  const a = document.createElement("a");
  a.href = url;
  a.download =
    (response.headers["x-filename"] as string) || `details-${fileId}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
